// extracted by mini-css-extract-plugin
export default {"journal-entries-container":"JournalEntriesMain_journal-entries-container__3jZQZ","journal-entries-tabs":"JournalEntriesMain_journal-entries-tabs__baXb2"};